import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
interface Props {
  title: string;
  subTitle: string;
  children?: ReactNode;
}
export default function HeaderDropDownTitle(t0) {
  const $ = _c(12);
  const {
    title,
    subTitle,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginTop: 4,
      width: {
        lg: 260
      },
      maxWidth: {
        md: 260
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      whiteSpace: "nowrap"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <Typography variant="h3" component="div" sx={t2}>{title}</Typography>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== subTitle) {
    t4 = <Typography variant="caption" color="textPrimary" component="div">{subTitle}</Typography>;
    $[4] = subTitle;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children) {
    t5 = children && <Box sx={{
      marginTop: 1
    }}>{children}</Box>;
    $[6] = children;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <Box sx={t1}>{t3}{t4}{t5}</Box>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}